import { render, staticRenderFns } from "./CreateApp.vue?vue&type=template&id=25446b4a"
import script from "./CreateApp.vue?vue&type=script&lang=js"
export * from "./CreateApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports